import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

// images
import { ReactComponent as CloseIconSvg } from '@src/images/common/close-icon.svg';

// Common Component
import Button from '@src/components/common/Button';
import Input from '@src/components/common/Input';

// interface
import { IMobileHeaderSearchBarWrapProps } from './ResponsiveHeader';

export const HeaderContainer = styled.header`
  display: inline-flex;
  flex: 0 0 99px;
  height: 99px;
  width: 100%;
  background-color: white;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eaeaea;
  padding-right: 40px;
  padding-left: 40px;

  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    position: sticky;
    z-index: 999;
    top: 0;
    left: 0;
    display: inline-flex;
    flex: 0 0 62px;
    height: 62px;
    width: 100%;
    min-width: auto;
    ${(props) => props.theme.mixin.convertMobileWidth('padding-right', 40)};
    ${(props) => props.theme.mixin.convertMobileWidth('padding-left', 40)};
  }
`;

export const MobileHeaderContainerLeft = styled.div``;
export const MobileHeaderContainerRight = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderContainerWrapper = styled.div`
  width: 1260px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    height: 100%;
  }
`;

export const LogoImg = styled.img`
  width: 196px;
  cursor: pointer;

  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    width: 178px;
  }
`;

export const LoginButton = styled(Link)`
  display: inline-flex;
  border: none;
  width: 86px;
  height: 44px;
  border-radius: 22px;
  background-color: ${(props) => props.theme.color.mainTheme};
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  justify-content: center;
  align-items: center;

  &:hover,
  &:active {
    color: #fff;
  }

  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    font-size: 12px;
    height: 32px;
    border-radius: 16px;
    width: auto;
    ${(props) => props.theme.mixin.convertMobileWidth('padding-right', 20)};
    ${(props) => props.theme.mixin.convertMobileWidth('padding-left', 20)};
  }
`;

export const HeaderRightContainer = styled.div`
  position: relative;
  display: flex;

  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    align-items: center;
  }
`;

export const NFTButton = styled(Button)`
  border: none;
  justify-content: center;
  align-items: center;
  width: 92px;
  height: 44px;
  border-radius: 22px;
  background-color: ${(props) => props.theme.color.mainTheme};
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  margin-right: 10px;

  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    font-size: 12px;
    height: 32px;
    border-radius: 16px;
    width: auto;
    ${(props) => props.theme.mixin.convertMobileWidth('padding-right', 20)};
    ${(props) => props.theme.mixin.convertMobileWidth('padding-left', 20)};
  }
`;

export const MyProfileButton = styled(Button)`
  border: none;
  padding: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  font-size: 0;
  overflow: hidden;

  @media screen and (max-width: ${(props) => props.theme.breakPoint.mobile}px) {
    width: 32px;
    height: 32px;
  }
`;

export const MyProfileButtonImg = styled.img`
  width: 100%;
  height: 100%;
`;

export const SubmenuContainer = styled.div`
  position: absolute;
  top: 50px;
  background-color: white;
  z-index: 10;
  right: 0;
  min-width: 140px;
  border: 1px solid #eaeaea;
`;

export const ProfileWrap = styled.div`
  position: relative;
`;

// export const SubmenuCloseContainer = styled.div`
//   position: absolute;
//   width: 100%;
//   height: 100vh;
//   background-color: transparent;
//   left: 0;
//   top: 0;
//   z-index: 9;
// `;

export const Submenu = styled(Button)`
  padding: 15px;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
  & + & {
    border-top: 1px solid #eaeaea;
  }
`;

export const SubmenuIcon = styled.img`
  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}
  ${(props) =>
    props.height &&
    css`
      height: ${props.height}px;
    `}
`;

export const SubmenuTitleText = styled.span<any>`
  color: #111111;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: -0.14px;
  line-height: normal;
  ${(props) =>
    props.marginLeft &&
    css`
      margin-left: ${props.marginLeft}px;
    `}
`;
